import * as v1 from './payment';
import * as v2 from './paymentV2';

// eunaCancelPayment is legacy-only (v1); it is not part of the PCI payments API.
export type PaymentApi = Omit<typeof v1, 'eunaCancelPayment'>;

export const buildPaymentApi = (pciEnabled: boolean): PaymentApi =>
  pciEnabled ? v2 : v1;
